import AFFINESticker from '../../../../templates/stickers/Contorted Stickers/Content/AFFiNE.svg';
import type { FC } from 'react';
import clsx from 'clsx';
import { authHeaderWrapper } from './share.css';

export const AuthHeader: FC<{
  title: string;
  subTitle?: string;
  className?: string;
}> = ({ title, subTitle, className }) => {
  return (
    <div className={clsx(authHeaderWrapper, className)}>
      <p>
        <img
          src={AFFINESticker}
          alt="AFFiNE"
          className="logo"
          style={{ width: 32, height: 32, objectFit: 'contain' }}
        />
        {title}
      </p>
      <p>{subTitle}</p>
    </div>
  );
};
